import React from 'react'
import { Link } from 'react-router-dom';
import BgImage from "../images/acfan.jpg";
import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedinIn, FaHome, FaEnvelope, FaWhatsapp, FaPhone } from "react-icons/fa";

import ContactHome from '../components/ContactHome';

function Contact() {
  return (
    <div className='container-fluid px-0 pt-5'>
    <div
  className="contact-banner d-flex align-items-center justify-content-center position-relative text-white"
  style={{
    backgroundImage: `url(${BgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "300px", // Mobile ke liye minimum height
  }}
>
  {/* Overlay */}
  <div
    className="overlay position-absolute w-100 h-100"
    style={{ backgroundColor: "rgba(0,0,0,0.5)", top: 0, left: 0 }}
  ></div>

  {/* Content */}
  <div className="container position-relative text-center py-5">
    <h1 className="fw-bold mb-3">Contact Us</h1>
    <p className="lead mb-4">
     Get in touch with SOLAR CLUB BHARAT for expert guidance and personalized solar solutions. We're here to answer your questions and help your business stay powered and efficient.
    </p>

    {/* Breadcrumbs */}
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb justify-content-center mb-0">
        <li className="breadcrumb-item">
          <Link to="/" className="text-white text-decoration-none">
            Home
          </Link>
        </li>
        <li className="breadcrumb-item active text-white" aria-current="page">
          Contact Us
        </li>
      </ol>
    </nav>
  </div>
</div>




      <div className=''>
        <ContactHome />
        <div className='text-center p-3 my-5'>
          <h2 className='fw-bold'>
            Contact Us
          </h2>
          <p>We're here to help you find the perfect solar energy solution tailored to your needs. Whether you have questions, need a consultation, or want a custom quote, our team is ready to assist you.</p>


          <div className="row mx-0 d-flex align-items-center">
            <div className="col-12 col-sm-6">
              <div className="info d-inline">
                <p><i className="fa-solid fa-envelope text-danger my-1"></i>info@solarclubbharat.com</p>
                <p><i className="fa-solid fa-envelope text-danger my-1"></i>support@solarclubbharat.com</p>
                {/* <p><i className="fa-solid fa-location-dot text-danger my-1"></i><span><b>Plot No. 9, Opp. Metro Pillar No. 84,
New Sanganer Road, Vivek Vihar,
Near Vivek Vihar Metro Station,
Jaipur, Rajasthan – 302019, India</p> */}
                <p><i className="fa-solid fa-location-dot text-danger my-1"></i><span><b>Branch Office:-</b></span>708, element Moll , Ajmer Road Jaipur 302019</p>
                <a href="#" className="btn-consult my-1">Free Consultation</a>
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <h6 className="fw-bold mb-3">Follow Us</h6>
              <div className="d-flex justify-content-center gap-3">
                <a href="/" className="social-icon home border border-danger"><FaHome /></a>
                {/* <a href="" className="social-icon envelope"><FaEnvelope /></a> */}
                <a href="https://wa.me/919573487504" className="social-icon whatsapp border border-danger"><FaWhatsapp /></a>
                <a href="tel:919573487504" className="social-icon phone border border-danger">
                  <FaPhone />
                </a>
              </div>
              <div className="d-flex gap-3 mt-3 justify-content-center">
                <a href="https://www.facebook.com/p/Swastik-Engineers-100068248691310/" className="social-icon facebook border border-danger"><FaFacebookF /></a>
                <a href="https://www.youtube.com/@swastikengineers7705" className="social-icon youtube border border-danger">
                  <FaYoutube />
                </a>
                <a href="https://www.instagram.com/swastikengineers01/" className="social-icon instagram border border-danger"><FaInstagram /></a>
                <a href="https://www.linkedin.com/in/manish-sharma-a01b9585?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="social-icon linkedin border border-danger"><FaLinkedinIn /></a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div>
        <iframe className='w-100 border border-5 border-danger' style={{ height: "450px" }} src="https://www.google.com/maps/embed?pb=!1m26!1m12!1m3!1d30079481.857624147!2d73.3185081407545!3d23.030683205066328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m11!3e6!4m3!3m2!1d22.256025599999997!2d114.1571584!4m5!1s0x396db5b556df683f%3A0x7d6f8475a2cb14a2!2sElements%20Mall%2C%20Shopping%2C%20Govindhgarh%20Road%2C%20near%20Govt%20Scholl%2C%20DCM%2C%20Hasteda%2C%20Jaipur%2C%20Rajasthan%20303602%2C%20India!3m2!1d26.8953654!2d75.7485213!5e0!3m2!1sen!2shk!4v1778848257437!5m2!1sen!2shk" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      </div>


    </div>
  )
}

export default Contact
